import 'vuetify/dist/vuetify.css'
import './main.css'

import 'babel-polyfill'

import Vue from 'vue'
import vuetify from './plugins/vuetify'

import App from './App'
import router from './router'
import store from './store'
import filters from './filters'
import auth from './auth'

require('es6-promise/auto')

Vue.config.productionTip = false

Object.keys(filters).forEach((key) => {
    const type = filters[key]
    Object.keys(type).forEach(k => Vue.filter(k, type[k]))
})

Vue.use(auth)

/* eslint-disable no-new */
new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
